import React, { useEffect, useState, useRef } from 'react';
const BONUSES = [{
  num: 1,
  title: 'Clases Salvavidas',
  image: 'https://cdn.magicpatterns.com/uploads/vbZ2eW3Gn5gJVkjyyAjpp8/BONo_1_sic.png',
  desc: 'Plan B Docente para cuando falta tiempo o surge un imprevisto.'
}, {
  num: 2,
  title: 'Evaluaciones Listas',
  image: 'https://cdn.magicpatterns.com/uploads/hXEBCrpoiNbiMFctEJLm3H/BONO_2_sic.png',
  desc: 'Pruebas escritas, trabajos prácticos y rúbricas claras.'
}, {
  num: 3,
  title: 'Mapa Anual',
  image: 'https://cdn.magicpatterns.com/uploads/u2RzM3QeiggdEN7x2H993p/BONO_3_sic.png',
  desc: 'Un año completo en una sola hoja. Qué dar y en qué orden.'
}, {
  num: 4,
  title: 'Banco de Ejemplos',
  image: 'https://cdn.magicpatterns.com/uploads/6MwKjK6Q24HogJAiZT3Zm3/BONo_4_sic.png',
  desc: 'Asientos contables explicados paso a paso para decir en voz alta.'
}];
export function BonusSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section ref={sectionRef} className="py-16 bg-gradient-to-b from-white to-slate-50" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <span className={`inline-block bg-green-100 text-green-700 font-bold px-6 py-2 rounded-full shadow-sm text-sm mb-5 border border-green-200 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`} data-id="element-4">
            🎁 BONOS GRATIS HOY
          </span>
          <h2 className={`text-3xl md:text-4xl font-black text-slate-900 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`} data-id="element-5">
            Te llevás{' '}
            <span className="text-orange-500" data-id="element-6">4 bonos exclusivos</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-7">
          {BONUSES.map((bonus, index) => <div key={index} className={`bg-white rounded-2xl overflow-hidden shadow-md border-2 border-slate-200 cursor-pointer group hover:border-blue-400 hover:shadow-lg transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${200 + index * 100}ms`
        }} onClick={scrollToPurchase} data-id="element-8">
              {/* Badges */}
              <div className="flex justify-between items-center px-3 pt-3" data-id="element-9">
                <span className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-10">
                  BONO {bonus.num}
                </span>
                <span className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-11">
                  GRATIS
                </span>
              </div>

              {/* Image */}
              <div className="p-3 pb-0" data-id="element-12">
                <div className="overflow-hidden rounded-xl" data-id="element-13">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto transform group-hover:scale-105 transition-transform duration-500" data-id="element-14" />
                </div>
              </div>

              {/* Text */}
              <div className="p-3 pt-2 md:p-4 md:pt-3" data-id="element-15">
                <h3 className="text-sm md:text-base font-bold text-slate-900 mb-1 group-hover:text-blue-600 transition-colors leading-tight" data-id="element-16">
                  {bonus.title}
                </h3>
                <p className="text-xs md:text-sm text-slate-500 leading-snug" data-id="element-17">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}